import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/mine").then(({ data }) => { setOrders(data); setLoading(false); });
  }, []);

  return (
    <div data-testid="account-page" className="max-w-5xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
      <div className="text-xs tracking-[0.3em] uppercase text-muted-foreground mb-4">◦ Your account</div>
      <h1 className="font-serif text-4xl lg:text-5xl tracking-tight">{user?.name}</h1>
      <p className="text-muted-foreground mt-2 text-sm">{user?.email}</p>

      <div className="mt-16">
        <h2 className="font-serif text-2xl lg:text-3xl tracking-tight mb-8">Orders</h2>
        {loading ? (
          <div className="text-muted-foreground">Loading…</div>
        ) : orders.length === 0 ? (
          <div className="text-muted-foreground">
            No orders yet. <Link to="/shop" className="text-foreground hover:text-primary underline underline-offset-4">Wander the studios →</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div key={o.id} className="border border-border/40 p-6 rounded-sm">
                <div className="flex justify-between items-start">
                  <div>
                    <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground">Order #{o.id.slice(0, 8)}</div>
                    <div className="font-serif text-xl mt-1">${Number(o.total).toFixed(2)}</div>
                    <div className="text-xs text-muted-foreground mt-1">{new Date(o.created_at).toLocaleDateString()}</div>
                  </div>
                  <span className={`text-xs px-3 py-1 border rounded-sm ${o.status === "paid" ? "border-primary text-primary" : "border-border text-muted-foreground"}`}>
                    {o.status}
                  </span>
                </div>
                <div className="mt-4 text-sm text-muted-foreground">
                  {o.items.map((i) => `${i.quantity}× ${i.title}${i.variant_label ? ` (${i.variant_label})` : ""}`).join(" · ")}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
